
  var _styles = {
  "loadMore-container": {
    "width": "10rem",
    "display": "flex",
    "flexDirection": "row",
    "justifyContent": "center"
  },
  "loadMore-button": {
    "display": "flex",
    "flexDirection": "row",
    "justifyContent": "center",
    "alignItems": "center",
    "width": "2.29333rem",
    "height": "0.64rem",
    "borderRadius": "0.66667rem",
    "marginBottom": "0.32rem",
    "backgroundColor": "rgb(255,255,255)"
  },
  "loadMore-text": {
    "fontSize": "0.32rem",
    "lineHeight": "0.42667rem"
  },
  "loadMore-arrow": {
    "marginLeft": "0.06667rem",
    "width": "0.26667rem",
    "height": "0.26667rem"
  }
};



  module.exports = _styles;
  